import { Box } from '@mui/material'
import React from 'react'
import RealGDPPerCapitaChangeChart from './RealGDPPerCapitaChangeChart'

export default function RealGDPPerCapitaChange() {
    return (
        <>
            <Box>
                <RealGDPPerCapitaChangeChart />
            </Box>
        </>
    )
}